import React from 'react';

type Variant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'purple';

const variants: Record<Variant, string> = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-gray-200 text-gray-700',
  warning: 'bg-gray-300 text-gray-700',
  danger: 'bg-gray-800 text-white',
  info: 'bg-primary-100 text-primary-700',
  purple: 'bg-gray-300 text-gray-700',
};

interface BadgeProps {
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
}

export function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}

export function getPriorityVariant(priority: string): Variant {
  const map: Record<string, Variant> = {
    low: 'default',
    medium: 'info',
    high: 'warning',
    critical: 'danger',
  };
  return map[priority] || 'default';
}

export function getStatusVariant(status: string): Variant {
  const map: Record<string, Variant> = {
    planning: 'info',
    in_progress: 'info',
    completed: 'success',
    cancelled: 'danger',
    todo: 'default',
    in_review: 'warning',
    done: 'success',
  };
  return map[status] || 'default';
}

export const priorityLabels: Record<string, string> = {
  low: 'Baixa',
  medium: 'Média',
  high: 'Alta',
  critical: 'Crítica',
};

export const statusLabels: Record<string, string> = {
  todo: 'A Fazer',
  in_progress: 'Em Andamento',
  in_review: 'Em Revisão',
  done: 'Concluído',
  planning: 'Planejamento',
  completed: 'Concluído',
  cancelled: 'Cancelado',
};
